import React from 'react';
import { Select } from 'antd';

const SocietyTypeSelect: React.FC<SocietyTypeSelectProps> = ({ onChange, value, placeholder, disabled = false }) => {
  return (
    <Select value={value} onChange={onChange} placeholder={placeholder} disabled={disabled}>
      <Select.Option value='Civil'>Sociedad Civil, Cooperativas y OSP</Select.Option>
      <Select.Option value='Mercantil'>Sociedad Mercantil (Organización)</Select.Option>
    </Select>
  );
};

export default SocietyTypeSelect;

interface SocietyTypeSelectProps {
  onChange?: (e: any) => any
  value?: any
  placeholder?: string
  disabled?: boolean
}